export default {
    apiKey: "AIzaSyDGWwHQNewZk-6d8V5BrbYuN_fSRfRyTNQ",
    authDomain: "whatsappclone-e7709.firebaseapp.com",
    projectId: "whatsappclone-e7709",
    storageBucket: "whatsappclone-e7709.appspot.com",
    messagingSenderId: "420357070352",
    appId: "1:420357070352:web:91ecd0596e9bab61903495",
    measurementId: "G-SXCEVCJZND"  
};
  